"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TGPageLabelWrapper_1 = __importDefault(require("./TGPageLabelWrapper"));
const Charts_1 = require("../Common/Charts");
// @ts-ignore
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
// TODO: [S5-3487] Strong typing for props.
const ChartFieldMap = {
    bar: Charts_1.TGBarChart,
    line: Charts_1.TGLineChart,
    pie: Charts_1.TGPieChart,
    scatterPlot: Charts_1.TGScatterPlotChart,
};
const TGPageChartField = props => {
    const { value, height, required, label, info, chartType, chartOptions } = props;
    const containerHeight = react_1.useMemo(() => Number(height) || 400, [height]);
    const ChartElement = react_1.useMemo(() => ChartFieldMap[chartType], [chartType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TGPageLabelWrapper_1.default, { required: required, readOnly: true, label: label, info: info, oneLine: false }),
        react_1.default.createElement("div", { style: { height: containerHeight } }, (!!ChartElement && !!(value === null || value === void 0 ? void 0 : value.data)) ? (react_1.default.createElement(ChartElement, Object.assign({}, chartOptions, value))) : (
        // TODO: [S5-3487] User-friendly indication of failed data load.
        react_1.default.createElement(CircularProgress_1.default, { color: "primary", size: 64 })))));
};
exports.default = TGPageChartField;
//# sourceMappingURL=TGPageChartField.js.map